import { ApolloError, gql, useMutation } from "@apollo/client";
import { CrMainCategoryInput, CrMainCategoryMutation, CrMainCategoryMutationVariables } from "../generated/graphql";

export interface ICrMainCategoryFormProps extends CrMainCategoryInput {}

const CR_MAIN_CATEGORY_MUTATION = gql`
  mutation crMainCategory($input: CrMainCategoryInput!) {
    crMainCategory(input: $input) {
      ok
      err
    }
  }
`;

export const useCrMainCategory = (
  onCompleted?: (data: CrMainCategoryMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CrMainCategoryMutation, CrMainCategoryMutationVariables>(
    CR_MAIN_CATEGORY_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};